export const LOCALE = {
  FR_CA: 'fr-CA',
  EN_CA: 'en-CA',
};

export const LOCALES = [
  {
    locale: 'fr-CA',
    name: 'Français',
  },
  {
    locale: 'en-CA',
    name: 'English',
  },
];

export const LOCALE_VALUES = Object.values(LOCALE);
